import { useContext } from 'react';
import { useMutation } from 'react-query';
import i18n from 'i18next';
import { GlobalStateContext } from 'app/providers/GlobalStateProvider';
import { updateLanguagePreference } from 'shared/api/profileApi';

const LANGUAGE_OPTIONS = [
  { value: 'id', label: 'Bahasa Indonesia' },
  { value: 'en', label: 'English' },
];

export const useLanguagePreference = () => {
  const { setLanguageSelected } = useContext(GlobalStateContext);

  const currentLanguage =
    i18n.language || localStorage.getItem('selectedLanguage') || 'en';

  const applyLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('selectedLanguage', lang);
    setLanguageSelected?.(lang);
  };

  const { mutate, isLoading: isChanging } = useMutation(
    (lang) =>
      updateLanguagePreference({ language_preference: lang.toUpperCase() }),
    {
      onSuccess: (_data, lang) => applyLanguage(lang),
    }
  );

  const changeLanguage = (lang, { onSuccess } = {}) => {
    if (lang === currentLanguage) return;

    const isWebView = localStorage.getItem('isWebView') === 'true';
    if (isWebView) {
      applyLanguage(lang);
      onSuccess?.();
      return;
    }

    mutate(lang, { onSuccess });
  };

  return {
    currentLanguage,
    isChanging,
    changeLanguage,
    languageOptions: LANGUAGE_OPTIONS,
  };
};
